module.exports = __webpack_public_path__ + "img/jacket-front-sub-raglan-zipper.89512b53.png";